module.exports = __webpack_public_path__ + "static/media/film-production-catering-banner.8897c598.jpg";